/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Level_EliteInputs */

const en_us2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite`)
};

const pt_br2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite`)
};

const es_419_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élite`)
};

const pt_pt2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite`)
};

const fr_fr2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élite`)
};

const de_de2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite`)
};

const it_it2_exercise_personal_strength_level_elite = /** @type {(inputs: Exercise_Personal_Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élite`)
};

/**
* | output |
* | --- |
* | "Elite" |
*
* @param {Exercise_Personal_Strength_Level_EliteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_level_elite = /** @type {((inputs?: Exercise_Personal_Strength_Level_EliteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Level_EliteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_level_elite(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_level_elite(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_level_elite(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_level_elite(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_level_elite(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_level_elite(inputs)
	return en_us2_exercise_personal_strength_level_elite(inputs)
});
export { exercise_personal_strength_level_elite as "exercise-personal.strength_level_elite" }